export default __webpack_public_path__ + "static/typography-image-a-77def982634a7a0e9663e1d75fea26d4.png";